export const defaultState = {
  isLoading: false,
  resultData: null,
  errorData: null
};
